/**
 * Workspace Service REST API
 *
 * Contact: ContactRequests@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Position } from './position';
import { Size } from './size';

export interface Window {
    id?: string;
    tabId: string;
    workspaceId?: string;
    name?: string;
    position?: Position;
    size?: Size;
    locked?: boolean;
    widgetToolbarState?: Window.WidgetToolbarStateEnum;
    selectedWidgetId?: string;
}
export namespace Window {
    export const WidgetToolbarStateEnum = {
        Default: 'DEFAULT',
        Expanded: 'EXPANDED',
        Collapsed: 'COLLAPSED'
    } as const;
    export type WidgetToolbarStateEnum = (typeof WidgetToolbarStateEnum)[keyof typeof WidgetToolbarStateEnum];
}
